import { render } from "./ColorBar.vue?vue&type=template&id=0c6bfa77&scoped=true&ts=true"
import script from "./ColorBar.vue?vue&type=script&lang=ts"
export * from "./ColorBar.vue?vue&type=script&lang=ts"

import "./ColorBar.vue?vue&type=style&index=0&id=0c6bfa77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6bfa77"]])

export default __exports__